const TestimonialSlide = ({testimonial, author, city}) => {
   return (
      <div className="testimonial-block text-center">
         <p>“{testimonial}"</p>
         <h6 className="text-olive">{author}, {city}</h6>
      </div>
   );
};
export default TestimonialSlide;
